export default __webpack_public_path__ + "static/media/paladin.272a219e.png";